import { render, staticRenderFns } from "./SEPARATOR.vue?vue&type=template&id=6a3f074a&scoped=true&"
import script from "./SEPARATOR.vue?vue&type=script&lang=js&"
export * from "./SEPARATOR.vue?vue&type=script&lang=js&"
import style0 from "./SEPARATOR.vue?vue&type=style&index=0&id=6a3f074a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3f074a",
  null
  
)

export default component.exports